module.exports = __webpack_public_path__ + "img/304FB1_69A1EF_5081DF_5C8CE6-256px.16e5b8d2.png";